import React from "react";
import useAppContext from '../../context/useAppContext';
import { getBrowserAlertText } from "../../helper/helper";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { DotButton, useDotButton } from "../../helper/EmblaCarouselDotButton";

const OsmanliHeader = ({ children }) => {
  const { innerTexts } = useAppContext();
  const SLIDE_COUNT = 4;
  const slides = Array.from(Array(SLIDE_COUNT).keys());
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay()]);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  return (
    <>
      <div className="bg">
        {getBrowserAlertText() ? (
          <div
            className="container-fluid information"
            style={{ textAlign: "center" }}
          >
            {getBrowserAlertText()}
          </div>
        ) : null}
        <header>
          <div className="container-fluid">
            <div
              className="row"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <a href="/" className="logo">

                  <picture>
                    <source srcSet="/images/logo.svg" type="image/svg+xml" />
                    <img src="/images/logo.png" alt="logo" />
                  </picture>
                </a>
              </div>
              <div
                style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}
              >
                <div className="header_right">
                  <a
                    href={innerTexts.companySecurityLink}
                    className="hr_box hr_box_security"
                  >
                    <img src="/images/OBjects.svg" alt="" />
                  </a>

                  <a
                    href={`mailto:${innerTexts.companyEmail}`}
                    className="hr_box hr_box_mail"
                  >
                    <img src="/images/mail.svg" alt="" />
                  </a>

                  <a
                    href={innerTexts.companyPhoneLink}
                    className="hr_box hr_box_phone"
                  >
                    <img src="/images/phone.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </header>

        {children}
      </div>

      <div className="container-fluid work_box first_work_box">
        <div className="container-fluid ">
          <div className="row">
            <div className="col-sm-3 col-md-3">
              <img src="images/giris.svg" alt="" />
              <span>
                <strong className="underline">Başlamadan Önce</strong>
              </span>
              <p>
                Yeni tip kimliğinizi yanınızda bulundurmanızı, sessiz ve
                aydınlık bir ortamda bulunmanızı, internet bağlantınızı kontrol
                etmenizi rica ederiz.
              </p>
            </div>

            <div className="col-sm-3 col-md-3">
              <img src="/images/mobil.svg" alt="" />
              <span>
                <strong className="underline">
                  Osmanlı Mobil Uygulamasını İndiriniz
                </strong>
              </span>
              <p>
                Web'den QR kod okutabilir veya uygulama mağazalarından
                indirebilirsiniz.
              </p>
            </div>

            <div className="col-sm-3 col-md-3">
              <img src="/images/onay.svg" alt="" />
              <span>
                <strong className="underline">Bilgilerinizi Doldurun</strong>
              </span>
              <p>
                Görüntülü hesap aç bölümünde bilgilerinizi doldurduktan sonra görüntülü görüşme başlat adımını seçiniz.
              </p>
            </div>
            <div className="col-sm-3 col-md-3">
              <img src="/images/hesap.svg" alt="" />
              <span>
                <strong className="underline">
                  Hesabınızı Kullanmaya Başlayın
                </strong>
              </span>
              <p>
                Hesap açılış işlemleriniz tamamlandıktan sonra size iletilecek
                şifre ve parola ile işlem yapmaya başlayabilirsiniz.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid work_box second_work_box">
        <div className="embla">
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              <div className="embla__slide">
                <img src="images/giris.svg" alt="" />
                <span>
                  <strong className="underline">Başlamadan Önce</strong>
                </span>
                <p>
                  Yeni tip kimliğinizi yanınızda bulundurmanızı, sessiz ve
                  aydınlık bir ortamda bulunmanızı, internet bağlantınızı
                  kontrol etmenizi rica ederiz.
                </p>
              </div>
              <div className="embla__slide">
                <img src="/images/mobil.svg" alt="" />
                <span>
                  <strong className="underline">
                    Osmanlı Mobil Uygulamasını İndiriniz
                  </strong>
                </span>
                <p>
                  Web'den QR kod okutabilir veya uygulama mağazalarından
                  indirebilirsiniz.
                </p>
              </div>
              <div className="embla__slide">
                <img src="/images/onay.svg" alt="" />
                <span>
                  <strong className="underline">Bilgilerinizi Doldurun</strong>
                </span>
                <p>
                  Görüntülü hesap aç bölümünde bilgilerinizi doldurduktan sonra görüntülü görüşme başlat adımını seçiniz.
                </p>
              </div>
              <div className="embla__slide">
                <img src="/images/hesap.svg" alt="" />
                <span>
                  <strong className="underline">
                    Hesabınızı Kullanmaya Başlayın
                  </strong>
                </span>
                <p>
                  Hesap açılış işlemleriniz tamamlandıktan sonra size iletilecek
                  şifre ve parola ile işlem yapmaya başlayabilirsiniz.
                </p>
              </div>
            </div>
          </div>
          <div className="embla__slide_controls">
            <div className="embla__controls">
              <div className="embla__dots">
                {scrollSnaps.map((_, index) => (
                  <DotButton
                    key={index}
                    onClick={() => onDotButtonClick(index)}
                    className={"embla__dot".concat(
                      index === selectedIndex ? " embla__dot--selected" : ""
                    )}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OsmanliHeader;
